import React from "react";
//import env from '../../../env';
import { usePost } from "../../../components";
import { useForm } from "../../../form";
import { Button, ErrorMessage } from "../../../components";
import { getCompreshensiveAssessmentModel } from "./compreshensiveAssessmentFormModel";
//import { gtm } from "../../../lib/tracking";
//import { useHistory } from "react-router-dom";

export function CompreshensiveAssessment(props) {
  const emailReceiver = props.emailReceiver;

  const model = getCompreshensiveAssessmentModel({});

  const form = useForm(model, { usePlaceholder: true });
  const [sendingStatus, setSendingStatus] = React.useState(null);
  const post = usePost();
  //const history = useHistory();

  function onSubmit(e) {
    form.validateForm(e, () => {
      const value = { ...form.getValue(), emailReceiver: emailReceiver };
      console.log("value", value);
      post.send("https://needsanalysis.goloans.com.au/api/NeedsAnalysis", value);
      setSendingStatus("pending");
    });
    console.log("submitting");
  }

  // if (status === 'done') {
  //   //navigate(`/task/view/${taskId}`)
  //   window.location.reload();
  // }

  if (post.done() && sendingStatus === "pending") {
    //var value = form.getValue();
    //gtm.sendEvent("contactFormSubmitted", { contactEmail: value.email });
    
    form.reset(model);
    setSendingStatus(null);
    setTimeout(() => {
      //history.push("/thank-you");
      const newId = post.response;
      window.location.href = `https://needsanalysis.goloans.com.au/client/${newId}/applicants`
    }, 1000);
  }

  const render = (name) => form.renderControl(name, null);

  return (
    <form className="contactForm">
      <div className="form-row">
        <div className="col-md-12 mb-2">
          <div className="form-title">Comprehensive Assessment</div>
        </div>
      </div>

      <div className="form-row" style={{ marginTop: "0.8rem" }}>
        <div className="col-md-12 mb-2">
          <p>
            {" "}
            For a comprehensive assessment within 1 business day. <br />
            Complete details below.
          </p>
        </div>
      </div>

      <div className="form-row">
        <div className="col-md-12 mb-2">
          <p>
            To start, please enter your email address <br />
            and reason for Enquiry.
          </p>
        </div>
      </div>

      <div className="form-row">
        <div className="col-md-12 mb-2">{render("email")}</div>
      </div>

      <div className="form-row">
        <div className="col-md-12 mb-2 text-col">Reason for Enquiry*:</div>
        <div className="col-md-12 mb-2">
          <div className="check__container">
            {render("purchase")}
            {render("refinance")}
            {render("debtConsolidation")}
          </div>
        </div>
      </div>

      <div className="form-row">
        <div className="col-md-12 mb-2">{render("broker")}</div>
      </div>

      <div className="form-row">
        <div className="col-md-12 mb-2">
          <div className="actions">
            <Button onClick={onSubmit} status={post.status}>
              {" "}
              Start Enquiry{" "}
            </Button>
            <ErrorMessage errors={post.errors} />
            {post.status === "done" && "Successfully sent!"}
          </div>
        </div>
      </div>
    </form>
  );
}
